import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { EditHistoryData, EditHistoryOptions } from './edit-history';
import * as _ from 'lodash';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-edit-history',
    templateUrl: './edit-history.component.html',
    styleUrls: ['./edit-history.component.scss'],
    standalone: false
})
export class EditHistoryComponent implements OnInit, OnChanges {

  @Input('options') options: EditHistoryOptions | undefined;
  @Input('data') data: EditHistoryData | undefined;

  parsedOptions: EditHistoryOptions;
  parsedData: EditHistoryData | undefined;

  isMobile: boolean = false;

  constructor(
    private globalservice: GlobalService,
  ) {

    this.parsedOptions = {
      hidden: false,
    };

    this.isMobile = this.globalservice.isMobile();

  }

  ngOnInit(): void {

    this.globalservice.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    })

  }

  ngOnChanges(change: { options: SimpleChange, data: SimpleChange }): void {
    if(change.data) {
      this.parseData(change.data.currentValue);
    }
    if(change.options) {
      this.parseOptions(change.options.currentValue);
    }
  }

  parseOptions(op: EditHistoryOptions): void {
    this.parsedOptions = _.cloneDeep(op);
  }

  parseData(da: EditHistoryData): void {
    this.parsedData = _.cloneDeep(da);
  }

  getDate(): Date {
    return new Date();
  }

}
